import React from "react";
import { Toolbar, Typography } from "@mui/material";

import { useTheme } from "@mui/material/styles";

const AddToolbar = ({ label }) => {
  const theme = useTheme();
  return (
    <Toolbar
      sx={{
        width: "100%",
        background: theme.palette.background.paper,
        marginTop: {
          xs: "130px",

          sm: "130px",
          md: "135px",
        },
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      }}
    >
      <Typography
        sx={{
          // color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818",
          ...theme.typography.h2,
          color: theme.palette.text.primary,
          fontSize: "20px",
          fontWeight: 600,
        }}
      >
        {label.name}
      </Typography>
    </Toolbar>
  );
};

export default AddToolbar;
